import { ref, onMounted, onBeforeUnmount } from "vue";

const isXL = ref(false);

const checkScreen = () => {
  isXL.value = window.innerWidth >= 1280; // Tailwind's xl breakpoint
};

export function useBreakpoint() {
  onMounted(() => {
    checkScreen(); // run once at mount
    window.addEventListener("resize", checkScreen);
  });

  onBeforeUnmount(() => {
    window.removeEventListener("resize", checkScreen);
  });

  return {
    isXL,
  };
}
